import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor() { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    let token = localStorage.getItem("AdminToken");

    let header = {};
    if (token) {
      header = {
        setHeaders: {
          token: token
        }
      };
    }

    request = request.clone(header);
    return next.handle(request);
  }
}